import { BehaviorSubject, Observable } from 'rxjs';
import { BlackjackListener } from 'game-logic';
import { PlayerControls, RoundState } from 'game-logic';
import { BaseUxGameListener } from './base-ux-game-listener';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { PAGE } from 'src/app/routes';

export class BlackjackUxGameListener extends BaseUxGameListener implements BlackjackListener {
  public get roundState$(): Observable<RoundState> {
    return this.roundState.asObservable();
  }
  public get availablePlayerControls$(): Observable<PlayerControls[]> {
    return this.availablePlayerControls.asObservable();
  }
  public get currentBet$(): Observable<number> {
    return this.currentBet.asObservable();
  }

  private roundState = new BehaviorSubject<RoundState>(RoundState.Loading);
  private availablePlayerControls = new BehaviorSubject<PlayerControls[]>([]);
  private currentBet = new BehaviorSubject<number>(0);

  constructor(private services: UxGameServices) {
    super();
  }

  onRoundStateChanged(state: RoundState): void {
    this.roundState.next(state);
  }

  onPlayerControlsChanged(controls: PlayerControls[]): void {
    this.availablePlayerControls.next(controls);
  }

  async onFatalError(context: string, error: unknown): Promise<void> {
    await this.services.analyticsService.handleError(error, context);

    const alert = await this.services.alertController.create({
      header: this.services.translocoService.translate('service.alert.fatal-reload-error-title'),
      message: this.services.translocoService.translate('service.alert.fatal-reload-error-message'),
      cssClass: 'alert',
      buttons: [
        {
          text: this.services.translocoService.translate('service.alert.ok-button'),
          cssClass: 'alert-button',
          handler: async () => {
            this.services.router.navigate([PAGE.LOADING]);
          },
        },
      ],
      backdropDismiss: false,
    });
    await alert.present();
  }

  onBetChanged(amount: number): void {
    this.currentBet.next(amount);
  }
}
